const RcaOffersPolicyInfo = ({ formData: { vehicle } }) => (
  <>
    <p>
      <span className="text-[#808080]">Autovehicul:</span>{" "}
      <span className="font-medium">
        {vehicle?.plateNo} - {vehicle?.commercialName}
      </span>
    </p>

    <p>
      <span className="text-[#808080]">Proprietar:</span>{" "}
      <span className="font-medium">
        {`${
          vehicle.vehicleOwner?.companyName ||
          vehicle.vehicleOwner?.lastName ||
          ""
        } ${vehicle.vehicleOwner?.firstName || ""}`}
      </span>
    </p>

    <p>
      <span className="text-[#808080]">Conducator auto:</span>{" "}
      <span className="font-medium">
        {vehicle.vehicleDriver?.lastName} {vehicle.vehicleDriver?.firstName}
      </span>
    </p>
  </>
);

export default RcaOffersPolicyInfo;
